let httpApi ='https://service.nutrient-top.cn' // 正式
let wsApi = 'wss://service.nutrient-top.cn' // 正式

// let httpApi ='https://test-service.nutrient-top.cn:48080' // 测试
// let wsApi = 'wss://test-service.nutrient-top.cn:48080' //测试
export const HTTP_REQUEST_URL = httpApi;
export const WS_REQUEST_URL = wsApi;